(function (app) {

    var PageModel = Backbone.Model.extend({
        defaults: {
            BasketMode: null,
            IsEmpty: null,
            IsAgeRestricted: null,
            IsAgreeWithAgeRestricted: null,
            PhoneVerification: {},
            isAuthorized: null
        },
        initialize: function () {
            _.bindAll(this, '_update', '_updatePayment', '_setAuthorized');
            app.checkout.orderXhr.done(this._update);
            app.checkout.paymentXhr.done(this._updatePayment);
            app.checkout.onUpdate(this._update);
            this._setAuthorized();
        },
        _setAuthorized: function () {
            this.set('isAuthorized', !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl'));
        },
        isAuthorized: function() {
            return this.get('isAuthorized');
        },
        onAuthChanged: function(cb) {
            this.on('change:isAuthorized', cb);
        },
        _update: function (data) {
            this._setAuthorized();
            this.set('IsEmpty', !!data.IsEmpty || !data.Items.length);
            this.set('BasketMode', data.BasketMode || 0);
            this.set('PhoneVerification', data.PhoneVerification);
            data.LastPaymentMethod !== null && this.set('LastPaymentMethodType', data.LastPaymentMethod);
            data.IsAgeRestricted != null && this.set('IsAgeRestricted', !!data.IsAgeRestricted);
        },
        _updatePayment: function (data) {
            //var method = _.findWhere(data.PaymentMethods, { Token: data.LastPaidToken });
            //this.set('CurrentMethod', new app.models.PaymentMethod(method));
            //this.set('LastPaidToken', data.LastPaidToken);
        },
        hasCurrentMethod: function () {
            //var method = this.get('CurrentMethod');
            //var val = method && method.toJSON();
            //return !!val;
        },
        IsAgreeWithAgeRestricted: function () {
            return !this.get('IsAgeRestricted') || !!this.get('IsAgreeWithAgeRestricted');
        }
    });

    app.models = _.extend({ page: new PageModel() }, app.models);
})(app);